import axios from "axios";
import { getSelectedLanguage } from "../helper/helper";

const config = {
  baseURL:process.env.REACT_APP_BASEURL
  
}

const api = axios.create(config);

api.defaults.headers["content-type"] = "application/json";


api.interceptors.request.use((item) => {
  item.headers["Accept-Language"] = getSelectedLanguage()?.toLowerCase();
  return item;
});

api.interceptors.response.use(
  resp => {
    return resp;
  },
  err => {
    console.log(err)
  }
);

export default api;
